import PropTypes from 'prop-types';
import React from 'react';

// material-ui
// We no longer need makeStyles from the legacy styling engine.
// import { makeStyles } from '@mui/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
// import SearchSection from './SearchSection';
import ProfileMenu from './ProfileSection/ProfileMenu';

// assets
import { IconMenu2 } from '@tabler/icons';

// The useStyles hook is no longer needed as we are moving the styles to the `sx` prop.

const Header = ({ handleLeftDrawerToggle }) => {
    // The classes variable is no longer needed.
    // const classes = useStyles();

    return (
        <>
            {/* logo & toggler button */}
            {/* The outer div is replaced with a Box and its styles are moved to the sx prop */}
            <Box
                sx={{
                    width: '228px',
                    display: 'flex',
                    '@media (max-width: 960px)': { // Equivalent of theme.breakpoints.down('md')
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    {/* The Avatar's styles are moved from classes.headerAvatar to the sx prop */}
                    <Avatar
                        variant="rounded"
                        sx={(theme) => ({
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.primary.light,
                            color: theme.palette.primary.dark,
                            '&:hover': {
                                background: theme.palette.primary.dark,
                                color: theme.palette.primary.light
                            }
                        })}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </Box>

            {/* header search */}
            {/* <SearchSection theme="light" /> */}

            {/* The grow divs are replaced with self-contained Box components for clarity */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            <ProfileMenu />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;